module.exports = __webpack_public_path__ + "img/txt_arena.869bbe49.svg";